import React from 'react';
import Link from 'redux-first-router-link';
import { USER } from '../../constants/User';

const SidebarMenu = ({user}) => {

  const admin = [1,2,3,4,5,6,7,8,9];
  const patient = [1,9];
  const company = [1,2,9];
  const staff= [2];

  let accessPages = [];

  switch (user.phanQuyen) {
    case USER.ROLE.ADMIN.CODE:
      accessPages = admin;
      break;
    case USER.ROLE.COMPANY.CODE:
      accessPages = company;
      break;
    case USER.ROLE.STAFF.CODE:
      accessPages = staff; 
      break;
    default:
      accessPages = patient;
      break;

  }

  const pages = [
    {id: 1,path: '/lich-su-kham-benh', className: 'fa fa-table', label: 'Danh sách khám bệnh'},
    {id: 2,path: '/xem-benh-su', className: 'fa fa-list-ul', label: 'Xem bệnh sử'},
    {id: 3,path: '/danh-sach-nguoi-dung', className: 'fa fa-list-ul', label: 'Danh sách người dùng'},
    {id: 4,path: '/danh-sach-cong-ty', className: 'fa fa-list-ul', label: 'Danh sách công ty'},
    {id: 5,path: '/danh-sach-nhan-vien', className: 'fa fa-list-ul', label: 'Danh sách nhân viên'},
    {id: 6,path: '/admin-dang-ky', className: 'fa fa-user-plus', label: 'Đăng ký người dùng'},
    {id: 7,path: '/dang-ky-user-cong-ty', className: 'fa fa-user-plus', label: 'Tạo user công ty'},
    {id: 8,path: '/dang-ky-user-nhan-vien', className: 'fa fa-user-plus', label: 'Tạo user nhân viên'},
    {id: 9,path: '/tu-van', className: 'fa fa-question-circle', label: 'Tư vấn'},
  ];

  return (
    <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
      <div className="menu_section">
        <h3>General</h3>
        <ul className="nav side-menu">
          {pages.map((page, i) => {
            return  accessPages.indexOf(page.id) > -1 ? <li key={i}><Link to={`${page.path}`}><i className={`${page.className}`}/>{page.label}</Link></li> : null;
          })}
        </ul>
      </div>

    </div>
  );
};

export default SidebarMenu;
